const actions = {
  setOperatorsByCountries({ commit, rootState }) {
    const api = rootState.Setup.apiInstance;
    // TODO: set the operator dynamic
    api.getOperatorsByCountries(undefined).then((response) => {
      commit('countries', response.data);
    }).catch(() => {
      // Nothing to do
      // console.error(error);
    });
  },
  setUbeeqoTitles({ commit, state, rootState }) {
    const api = rootState.Setup.apiInstance;
    api.getUbeeqoTitles(state.locale).then((response) => {
      commit('titles', response.data.data);
    }).catch(() => {
      // Nothing to do
      // console.error(error);
    });
  },
};
export default actions;
